import { render, staticRenderFns } from "./wxCustomerSendList.vue?vue&type=template&id=576c25b0&scoped=true&"
import script from "./wxCustomerSendList.vue?vue&type=script&lang=js&"
export * from "./wxCustomerSendList.vue?vue&type=script&lang=js&"
import style0 from "./wxCustomerSendList.vue?vue&type=style&index=0&id=576c25b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576c25b0",
  null
  
)

export default component.exports